import {UsersList} from '../../UsersList/UsersList'

export const CreateAudience = () => {
  return <UsersList isCreateAudience={true} />
}
